import React from "react";
import AdminDashboardHome from "../../components/AdminSideComponents/AdminDashboard/AdminDashboardHome";

const Dashboard = () => {
  return (
    <div className="dashboardContainer bg-[#F3F6FB] min-h-screen p-6">
      <AdminDashboardHome />
    </div>
  );
};

export default Dashboard;